import { Card, Menu, MenuProps } from "antd";
import { useContext, useEffect, useMemo, useState } from "react";
import { AuthenticationContext } from "../../../contexts/authentication-context";
import { CompanyContext } from "../../../contexts/company-context";
import { PageContainer } from "@ant-design/pro-layout";
import { CorporationOperation } from "../../../serviceoperation/CorporationOperation";
import { CorpDetailAPIEntity } from "../../../serviceoperation/entity/CorporationOperationEntity";
import OrgLocations from "./orgLocations";
import CorpMetadataForm from "./orgMetadata";
import OrgTimeOffReasons from "./orgTimeOffReasons";
import OrgSubscription from "./orgSubscription";
import {
  ClockCircleOutlined,
  FileDoneOutlined,
  SettingOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import OverviewTab from "./components/tabs/OverviewTab";
import { MapPin, TimerOff, Receipt } from "lucide-react";
import LocationsTab from "./components/tabs/LocationsTab";
import ScheduleTemplatesTab from "./ScheduleTemplatesTab";
import TaskTemplatesTab from "./TaskTemplatesTab";
import IntegrationsTab from "./components/tabs/integrationsTab";
import { useSearchParams } from "react-router-dom";

const OrgLayout = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  //const tab = searchParams.get("tab") ?? "overview";

  const setTab = (key: string, integrationmsg?: string | null) => {
    const params = new URLSearchParams(searchParams);

    params.set("tab", key);

    if (integrationmsg) {
      params.set("msg", integrationmsg);
    } else {
      params.delete("msg");
    }

    setSearchParams(params, { replace: true });
  };

  const userInfo = useContext(AuthenticationContext)?.userInfo;
  const { selectedCompany } = useContext(CompanyContext);
  const [corpProfile, setCorpProfile] = useState<CorpDetailAPIEntity>();

  const defaultSelectedKey = searchParams.get("tab") ?? "overview";
  const [currentTab, setCurrentTab] = useState<string>(defaultSelectedKey);

  type MenuItem = Required<MenuProps>["items"][number];

  const items: MenuItem[] = [
    {
      label: "Overview",
      key: "overview",
      icon: <FileDoneOutlined />,
    },
    {
      label: "Settings",
      key: "settings",
      icon: <SettingOutlined />,
    },
    {
      label: "Branches",
      key: "branches",
      icon: <MapPin size={16} />,
    },
    {
      label: "Time Off",
      key: "timeOff",
      icon: <TimerOff size={16} />,
    },
    {
      key: "scheduletemplates",
      label: "Schedule Templates",
      icon: <ClockCircleOutlined size={16} />,
    },
    {
      key: "tasktemplates",
      label: "Task Templates",
      icon: <FileTextOutlined size={16} />,
    },
    {
      key: "integrations",
      label: "Integrations",
      icon: <ClockCircleOutlined size={16} />,
    },
    {
      label: "Subscription",
      key: "Subscription",
      icon: <Receipt size={16} />,
    },
  ];

  const handleTabChange = (event: any) => {
    setCurrentTab(event.key);
    setTab(event.key);
  };

  useEffect(() => {
    const validTabs = items.map((t) => t!.key);
    if (!validTabs.includes(currentTab)) {
      setTab("overview");
    }
  }, [currentTab]);

  useMemo(() => {
    const employeeOps = new CorporationOperation();
    const loggedInUserID = userInfo?.employeeCorporation
      ?.filter((y) => y.corporationId === selectedCompany?.corporationId)
      .map((y) => y.employeeId)
      .at(0);
    //CurrentlY Logged In user same as the Schedule Id User??

    employeeOps
      .getCorpByIdAsync(selectedCompany?.corporationId as number)
      .then((x) => {
        setCorpProfile(x.data!);
      });
  }, [selectedCompany, userInfo]);

  const renderComponent = () => {
    switch (currentTab) {
      case "overview":
        return <OverviewTab />;
      case "settings":
        return <CorpMetadataForm newCorpData={corpProfile?.preference ?? []} />;
      case "branches":
        return <LocationsTab />;
      case "timeOff":
        return <OrgTimeOffReasons />;
      case "integrations":
        return <IntegrationsTab msg={searchParams.get("msg")} />;
      case "Subscription":
        return <OrgSubscription />;
      case "scheduletemplates":
        return <ScheduleTemplatesTab />;
      case "tasktemplates":
        return <TaskTemplatesTab />;
      default:
        return <OrgLocations />;
    }
  };
  return (
    <PageContainer subTitle="Settings to configure your basic details, and notifications.">
      {/*<Row gutter={16}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
        >
          <Card size="default">
            <div style={{ marginTop: "8px", textAlign: "right" }}>
              <Tag color={corpProfile?.isActive ? "blue" : "volcano"}>
                {corpProfile?.isActive
                  ? "Status: Active"
                  : "Status: Terminated"}
              </Tag>
            </div>
            <Row>
              <Col span={24}>
                <Space.Compact
                  block
                  direction="horizontal"
                  style={{ width: "100%", justifyContent: "center" }}
                >
                  <Avatar
                    size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
                    src={
                      <img
                        src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"
                        alt="avatar"
                      />
                    }
                  />
                </Space.Compact>
                <br></br>
                <Space.Compact
                  block
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  <Title level={4}>{corpProfile?.name}</Title>
                </Space.Compact>
                <Space.Compact
                  block
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  {corpProfile?.description}
                </Space.Compact>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 16 }}
          xl={{ span: 16 }}
        >
          <Card size="default">
            <Menu
              onClick={handleTabChange}
              mode="horizontal"
              defaultSelectedKeys={[defaultSelectedKey]}
              selectedKeys={[currentTab]}
              items={items}
              style={{ marginTop: -12 }}
            />
            {renderComponent()}
          </Card>
        </Col>
      </Row>*/}
      <Card size="default">
        <Menu
          onClick={handleTabChange}
          mode="horizontal"
          defaultSelectedKeys={[defaultSelectedKey]}
          selectedKeys={[currentTab]}
          items={items}
          style={{ marginTop: -12 }}
        />
        {renderComponent()}
      </Card>
    </PageContainer>
  );
};

export default OrgLayout;
